import { useEffect, useState } from 'react'
import { company, customerData } from '../utilities/CustomerData'
import { apiURL } from '../utilities/URLs'
import { refreshAccessToken } from '../utilities/extensions'
import { useNavigate } from 'react-router-dom'

export default function Account({ setShowNavBar }) {
  const navigate = useNavigate()

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    document.title = `${company.companyName} | My Account`
  }, [])

  const handleChangePassword = async () => {
    if (password === confirmPassword) {
      const passwordInfo = {
        customerId: customerData.customerLeadData.leadContact.contactId,
        password: password
      }

      const form = new FormData()
      form.append('passwordInfo', JSON.stringify(passwordInfo))

      const updatePasswordResponse = await fetch(`${apiURL}/api/updatePassword`, {
        method: 'PUT',
        body: form,
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const updatePasswordData = await updatePasswordResponse.json()
      if (updatePasswordData.response.error) {
        if (updatePasswordData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleChangePassword() : navigate('/', { state: { expired: true } })
        } else {
          setError(updatePasswordData.response.error)
          setTimeout(() => {
            setError('')
          }, 2000)
        }
      } else {
        setError('Password Updated!')
        setTimeout(() => {
          setError('')
        }, 2000)
      }
    } else {
      setError('Passwords Do Not Match.')
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }

  const handleLogout = async () => {
    const clearCookieResponse = await fetch(`${apiURL}/api/clearCookie`)
    const clearCookieData = await clearCookieResponse.json()
    if (clearCookieData.response.error)
      console.error(clearCookieData.response.error)
    else {
      localStorage.removeItem('customerAccessToken')
      setShowNavBar(false)
      navigate('/')
    }
  }

  return (
    <div className='flex flex-col items-center mt-10 h-[calc(100vh-72px)]'>
      <h2 className='text-3xl font-bold mb-20'>My Account</h2>
      <div className='bg-white p-8 rounded-lg shadow-lg flex flex-col items-center'>
        <h2 className='text-2xl font-semibold text-center mb-10'>Change Password</h2>
        <div className='mb-4'>
          <label htmlFor='password' className='block text-sm font-medium text-gray-700 text-left'>Password</label>
          <input type='password' id='password' name='password' required placeholder='Password' value={password} onChange={(e) => setPassword(e.target.value)}
            className='mt-1 p-2 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:ring-indigo-300' />
        </div>
        <div className='mb-10'>
          <label htmlFor='password' className='block text-sm font-medium text-gray-700 text-left'>Confirm Password</label>
          <input type='password' id='password' name='password' required placeholder='Confirm Password' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
            className='mt-1 p-2 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:ring-indigo-300' />
        </div>
        <button onClick={() => handleChangePassword()} className='px-4 py-2 bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white rounded'>
          Change Password
        </button>
        {error.length > 0 && (
          <p className='text-red-600'>{error}</p>
        )}
      </div>
      <button onClick={() => handleLogout()} className='mt-10 px-4 py-2 text-white rounded bg-secondaryColor hover:bg-secondaryDarkColor transition duration-200'>Logout</button>
    </div>
  )
}